import { Editor } from "@tiptap/react";
import { useMemo } from "react";
import { AlignmentOption } from "../types";
import { useTextmenuCommands } from "./useTextmenuCommands";
import { useTextmenuStates } from "./useTextmenuStates";

export const useTextmenuAlignments = (editor: Editor | null) => {
    const commands = useTextmenuCommands(editor);
    const states = useTextmenuStates(editor);

    // biome-ignore lint: useExhaustiveDependencies
    const options = useMemo<AlignmentOption[]>(() => {
        return [
            {
                tooltip: "Align left",
                tooltipShortcut: ["Shift", "Mod", "L"],
                icon: "AlignLeft",
                onClick: () => commands.onAlignLeft(),
                id: "alignLeft",
                disabled: () => !editor?.can().setTextAlign("left"),
                isActive: () => states.isAlignLeft,
            },
            {
                tooltip: "Align center",
                tooltipShortcut: ["Shift", "Mod", "E"],
                icon: "AlignCenter",
                onClick: () => commands.onAlignCenter(),
                id: "alignLeft",
                disabled: () => !editor?.can().setTextAlign("center"),
                isActive: () => states.isAlignCenter,
            },
            {
                tooltip: "Align right",
                tooltipShortcut: ["Shift", "Mod", "R"],
                icon: "AlignRight",
                onClick: () => commands.onAlignRight(),
                id: "alignLeft",
                disabled: () => !editor?.can().setTextAlign("right"),
                isActive: () => states.isAlignRight,
            },
            {
                tooltip: "Justify",
                tooltipShortcut: ["Shift", "Mod", "J"],
                icon: "AlignJustify",
                onClick: () => commands.onAlignJustify(),
                id: "alignJustify",
                disabled: () => !editor?.can().setTextAlign("justify"),
                isActive: () => states.isAlignJustify,
            },
        ];
    }, [editor, editor?.state]);

    return options;
};
